import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import { LOGIN_URL } from '@/utils/system_constants/constant.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { get_api_error_message, get_api_response_message, parse_api_data } from '@/utils/api_error_message';

export default {
  name: 'UserLogin',
  components: {
    OnboardingIndex
  },
  mixins: [alert_mixin],
  data() {
    return {
      title: 'Welcome Back',
      submitButtonText: 'Sign In',
      url_forgot_password: '/forgot_password',
      verification_running: false,
      username: '',
      password: '',
      show_password: false
    };
  },
  methods: {
    async login_function() {
      if (!this.username || !this.password) {
        this.show_error('Please enter your username and password.');
        return;
      }

      this.verification_running = true;

      try {
        const response = await axios.post(LOGIN_URL, {
          username: this.username,
          password: this.password
        });

        const response_data = parse_api_data(response.data);

        if (response_data?.status && response_data.status !== 'success') {
          this.show_error(get_api_response_message(response_data, 'Login failed.'));
          return;
        }

        if (!response_data?.token) {
          this.show_error(get_api_response_message(response_data, 'Login failed.'));
          return;
        }

        sessionStorage.setItem('token', response_data.token);
        sessionStorage.setItem('is_aic_one_login', false);

        this.$store.dispatch('setCurrentUserId', response_data.user_id);
        this.$store.dispatch('setCurrentLeadId', response_data.lead_id);
        this.$store.dispatch('setCurrentRole', response_data.role_type);
        this.$store.dispatch('setCurrentLeadName', response_data.full_name);

        this.$router.push({ name: 'CommandCentre' });
      } catch (error) {
        this.show_error(get_api_error_message(error, 'Login failed.'));
      } finally {
        this.verification_running = false;
      }
    },

    toggle_password_visibility() {
      this.show_password = !this.show_password;
    }
  }
};
